import styled from 'styled-components';
import { colorTelusPurple } from '@tds/core-colours/dist/index.cjs';

export const Heading = styled.p`
  padding: 5git px 0;
  font-size: 24px;
  color: ${colorTelusPurple};
`;

export const Text = styled.p`
  font-weight: ${props => (props.bold ? '600' : props.fontWeight || '400')};
  font-size: 16px;
  display: inline;
  letter-spacing: -0.2px;
  color: ${props => props.color};
`;

export const customStyles = `
  overflow: scroll;
  max-height: 100% !important;
  height:100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  `;
export const InputWrapper = styled.div`
  input[type='text'] {
    height: 3rem;
    margin: 0;
    outline: 0;
    text-overflow: ellipsis;
    border-color: #54595f;
    backgroundcolor: #fff;
    padding: 0.5rem 3rem 0.5rem 1rem;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    wordwrap: break-word;
    font-size: 1rem;
    letter-spacing: -0.8px;
    line-height: 1.5;
    font-weight: 400;
    color: #2a2c2e;
    min-height: 3rem;
    max-height: 3rem;
    width: 100%;
    margin: 8px 0;

    :focus {
      box-shadow: rgb(84, 89, 95) 0px 0px 4px 1px;
      background-color: rgb(255, 255, 255);
      border-color: transparent;
    }
  }
  #basic-typeahead {
    max-height: 200px !important;
  }
`;
